export function format(date: Date | number | string): string {
  const d = new Date(date);
  const day = padWithZeros(d.getDate(), 2);
  const month = padWithZeros(d.getMonth() + 1, 2);
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

function padWithZeros(value: string | number, length: number): string {
  const padValue = Array(length + 1).join('0');
  return `${padValue}${value}`.substr(-length);
}
